import { useEffect, useState } from 'react'

export type CurrentWeather = {
  temperature: number
  code: number
  isDay: boolean
}

type OpenMeteoResponse = {
  current?: { temperature_2m?: number; weather_code?: number; is_day?: number }
}

const REFRESH_MS = 15 * 60 * 1000

/** Current weather for the given coordinates via Open-Meteo (no API key needed). */
export function useWeather(latitude: number | null, longitude: number | null): CurrentWeather | null {
  const [weather, setWeather] = useState<CurrentWeather | null>(null)

  useEffect(() => {
    if (latitude === null || longitude === null) return
    let cancelled = false

    const load = async () => {
      try {
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,weather_code,is_day`
        const response = await fetch(url)
        if (!response.ok) return
        const data: OpenMeteoResponse = await response.json()
        const current = data.current
        if (cancelled || !current || typeof current.temperature_2m !== 'number') return
        setWeather({
          temperature: Math.round(current.temperature_2m),
          code: current.weather_code ?? -1,
          isDay: current.is_day !== 0,
        })
      } catch {
        // Weather is optional; keep it hidden on failure.
      }
    }

    load()
    const id = window.setInterval(load, REFRESH_MS)
    return () => {
      cancelled = true
      window.clearInterval(id)
    }
  }, [latitude, longitude])

  return weather
}
